import { CreateElement } from 'vue';

import PopoverModal from '@/components/modals/vfm/PopoverModal.vue';
import { VFMHelper } from '@/helpers/vfm/vfm-helper';
import { PopoverOptions } from '@/helpers/vfm/types';

const create = async ({ popoverProps, component, componentProps, onSlot, ...props }: PopoverOptions) => {
	await VFMHelper.ensureVfmCss();

	const { promise, dismiss } = VFMHelper.open({
		type: 'popover',
		slotComponent: {
			render(h: CreateElement) {
				return h(PopoverModal, { props: popoverProps }, [
					h(component, {
						props: componentProps,
						on: {
							dismiss,
							...(onSlot || {}),
						},
					}),
				]);
			},
		},
		...props,
	});

	return promise;
};

export const PopoverHelper = {
	create,
};
